import Api from "../../../util/Api";

export default function getInitState() {
    return {
        labHandleHistoryDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        labHandleHistoryRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showLabDocuments'
            }
        ],
        labHandleHistoryActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        lanHandleHistorySearchFields: [
            {
                name: "originalId",
                label: "Labor ID",
                formSize: 4,
                formType: "number"
            },
            {
                name: "operation",
                label: "Művelet",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedFrom",
                label: "History készítésének dátuma (tól)",
                formSize: 4,
                formType: 'date'
            },
            {
                name: "histCreatedTo",
                label: "History készítésének dátuma (ig)",
                formSize: 4,
                formType: 'date'
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "labTypeId",
                label: "Labor típus",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllLabHandleType,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "statusId",
                label: "Állapot",
                formSize: 4,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllLabHandleStatus,
                    additionalApiCallbackParams: {sendToSynlab: false},
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
        ],
        labHandleHistoryHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                sort: false
            },
            {
                name: "originalId",
                label: "Labor ID",
                visibility: true,
                sort: true,
            },
            {
                name: "operation",
                label: "Művelet",
                sort: true,
                slot_name: "operation_format",
                visibility: true,
                formType: 'select',
                selectOptions: {
                    externalOptionList: [
                        {id: 'INSERT', text: 'Létrehozás'},
                        {id: 'DELETE', text: 'Törlés'},
                        {id: 'UPDATE FROM', text: 'Módosítás (eredeti)'},
                        {id: 'UPDATE TO', text: 'Módosítás (új)'},
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                sort: true,
                visibility: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "histCreatedOn",
                label: "History készítésének dátuma",
                slot_name: "hist_created_on_format",
                sort: true,
                visibility: true
            },
            {
                name: "patient.name",
                label: "Páciens",
                visibility: true
            },
            {
                name: "patient.prefixedId",
                label: "Technikai azonosító",
                visibility: true
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                visibility: true
            },
            {
                name: "labType.text",
                label: "Labor típus",
                visibility: true
            },
            {
                name: "resultDate",
                label: "Határidő",
                visibility: true,
                slot_name: "resultDate_format"
            },
            {
                name: "startDate",
                label: "Küldés dátuma",
                visibility: true,
                slot_name: "startDate_format"
            },
            {
                name: "status.text",
                label: "Állapot",
                visibility: true
            },
            {
                name: "attendanceId",
                label: "Ellátás azonosító",
                visibility: false
            },
            {
                name: "company",
                label: "Company",
                visibility: false
            },
            {
                name: "companyId",
                label: "Cég azonosító",
                visibility: false
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false
            },
            {
                name: "deleted",
                label: "Státusz",
                visibility: false
            },
            {
                name: "doctor",
                label: "Doctor",
                visibility: false
            },
            {
                name: "doctorId",
                label: "Orvos azonosító",
                visibility: false
            },
            {
                name: "fileName",
                label: "Fájl név",
                visibility: false
            },
            {
                name: "filePath",
                label: "Fájl útvonal",
                visibility: false
            },
            {
                name: "labType",
                label: "LabType",
                visibility: false
            },
            {
                name: "labTypeId",
                label: "Labor típus azonosító",
                visibility: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false
            },
            {
                name: "patient",
                label: "Páciens",
                visibility: false
            },
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false
            },
            {
                name: "status",
                label: "Status",
                visibility: false
            },
            {
                name: "statusId",
                label: "Állapot azonosító",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ],

        labDocumentHistoryRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showLabDocument'
            }
        ],
        labDocumentHistoryHeaderFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                sort: false
            },
            {
                name: "originalId",
                label: "Dok. ID",
                filter: {
                    type: "simple",
                },
                visibility: true,
                sort: true,
            },
            {
                name: "operation",
                label: "Művelet",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: "operation_format",
                sort: true,
            },
            {
                name: "histCreatedBy",
                label: "History készítője",
                filter: {
                    type: "simple",
                },
                visibility: true,
                sort: true,
            },
            {
                name: "histCreatedOn",
                label: "History készítésének dátuma",
                visibility: true,
                sort: true,
                slot_name: "hist_created_on_format",
            },
            {
                name: "labId",
                label: "Labor ID",
                visibility: true
            },
            {
                name: "fileName",
                label: "Fájl név",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "fileData",
                label: "Fájl",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ]
    }
}
